import SaveAltIcon from '@mui/icons-material/SaveAlt'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { useCallback } from 'react'

type DownloadImageButtonProps = {
    src: string
}

export const DownloadImageButton = ({ src }: DownloadImageButtonProps) => {
    const handleDownload = useCallback(async () => {
        try {
            const response = await fetch(src, { mode: 'cors' })
            if (!response.ok) throw new Error()
            const blob = await response.blob()

            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = decodeURI(src).split('/').pop()
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()
            URL.revokeObjectURL(url)
        } catch {
            console.log('Не удалось скачать изображение.')
        }
    }, [src])

    return (
        <Tooltip title="Скачать изображение">
            <IconButton
                sx={{ color: '#fff', background: '#605c5c', borderRadius: '32px' }}
                onClick={handleDownload}>
                <SaveAltIcon />
            </IconButton>
        </Tooltip>
    )
}
